const apiUrl = import.meta.env.VITE_API_URL;
const reportsApiUrl = import.meta.env.VITE_REPORTS_API_URL || 'http://localhost:3001';

export const ENDPOINT = `${apiUrl}/api/v2`;
export const ADMIN_ENDPOINT = `${apiUrl}/api/v1/admin`;
export const ADMIN_ENDPOINT_SHORT = `${apiUrl}/api/v1`;
export const REPORTS_ENDPOINT = `${reportsApiUrl}/api`;
export const VEHICLES = 'vehicles';
export const CONTACTS = 'contacts';
export const ANALYTICS = 'analytics';
export const DEALS = 'deals';

export const SHOW_REMOVE_IMAGES_BTN = false;
export const CAN_EDIT_INTEGRATIONS = false;
